<template>
  <div class="border-t my-5" />
</template>
